var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesStocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8858 6.62571C22.8611 -0.468632 12.0305 1.71436 8.49073 6.43934C4.95092 11.1643 14.8625 14.1466 18.4597 21.5132C23.3108 31.4477 36.4168 15.4936 28.8858 6.62571Z",
    fill: "#001F4B",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28V25.4667L6 23.4667V28H4ZM9.5 28V20.1333L11.5 18.1333V28H9.5ZM15 28V18.1333L17 20.1667V28H15ZM20.5 28V20.1667L22.5 18.1667V28H20.5ZM26 28V14.8L28 12.8V28H26ZM4 20.1333V17.3L13.3333 8.03333L18.6667 13.3667L28 4V6.83333L18.6667 16.2L13.3333 10.8667L4 20.1333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesStocks);
export default __webpack_public_path__ + "static/media/features-stocks.f8a3a76a.svg";
export { ForwardRef as ReactComponent };